import PaymentErrorBox from 'shared-assets/components/PaymentSolutions/ReceiptPage/PaymentErrorBox';

angular
  .module('kareo.ui.shared.directives.payment-error-box', [
    'react'
  ])
  .directive('paymentErrorBox', dcPaymentErrorBox);

dcPaymentErrorBox.$inject = ['reactDirective'];

function dcPaymentErrorBox(reactDirective) {
  const bindings = {
    message: '=',
    label: '=',
    href: '=',
  };

  return reactDirective(PaymentErrorBox, bindings, props => {
    return props;
  });
}
